import React, { memo, useCallback } from 'react';

import downloadFile from 'src/utils/downloadFile';

import Button from '../../helpers/Button';
import DropDown, { DropDownElement } from '../../helpers/DropDown';

import style from './style.module.css';

const ContactActionsComponent = props => {
  const { values, showSave, onSave, vCardUrl } = props;

  const handleDownloadVCard = useCallback(() => {
    downloadFile({ url: vCardUrl });
  }, [vCardUrl]);

  const footerDropDown = values.get('footerDropDown').map((element, i) => {
    const attributes = element.get('attributes').toJS();

    return (
      <DropDownElement {...attributes} key={i} onClick={props[element.get('onClickField')]}>
        {element.get('name')}
      </DropDownElement>
    );
  });

  return (
    <div className={style.host}>
      <Button onClick={handleDownloadVCard}>
        <i aria-hidden="true" className="fa fa-download" /> Download a vCard
      </Button>

      <DropDown
        align="right"
        buttonContent="New"
        className="btn-default btn-xs"
        id="dropdownMenu7"
        wrapperClassName="ib"
      >
        {footerDropDown}
      </DropDown>

      <Button className="btn-primary" disabled={!showSave} onClick={onSave}>
        <i aria-hidden="true" className="fa fa-check" /> Save
      </Button>
    </div>
  );
};

/** Contact page toolbar actions: vCard download, New menu and Save. */
export const ContactActions = memo(ContactActionsComponent);
